import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import "../styles/CustomerDashboard.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { apiUrl } from "../lib/api";

function ShopperIcon({ name, className = "" }) {
  const icons = {
    menu: (
      <path
        d="M4 7h16M4 12h16M4 17h16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.8"
      />
    ),
    bell: (
      <>
        <path
          d="M9 18h6M7 15.5h10l-1.2-1.7V11a3.8 3.8 0 0 0-7.6 0v2.8L7 15.5Z"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.8"
        />
      </>
    ),
    search: (
      <>
        <circle cx="10.5" cy="10.5" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="m14 14 4 4" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
      </>
    ),
    home: (
      <path
        d="M5.5 10.2 12 5l6.5 5.2V18H14v-4h-4v4H5.5v-7.8Z"
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    ),
    categories: (
      <>
        <rect x="4.5" y="5" width="6.2" height="6.2" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <rect x="13.3" y="5" width="6.2" height="6.2" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <rect x="4.5" y="13.8" width="6.2" height="6.2" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <rect x="13.3" y="13.8" width="6.2" height="6.2" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
      </>
    ),
    cart: (
      <path
        d="M5 6h2l1.4 7.2h8.5l2-5.2H8.1M9.5 18.2a1 1 0 1 1 0 .1Zm7 0a1 1 0 1 1 0 .1Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    ),
    orders: (
      <>
        <rect x="6" y="4.5" width="12" height="15" rx="2.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
        <path d="M9 9.2h6M9 12.5h6M9 15.8h4" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.7" />
      </>
    ),
    profile: (
      <>
        <circle cx="12" cy="9" r="3.4" fill="none" stroke="currentColor" strokeWidth="1.7" />
        <path d="M5.5 18c1.8-2.7 4.2-4 6.5-4s4.7 1.3 6.5 4" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.7" />
      </>
    ),
    produce: (
      <path
        d="M12 19c4.4-2.2 6.8-6 6.8-10.8-4.9.1-8.2 2.3-9.8 6.5.1-3-.8-5.3-2.8-6.7-1.5 2.8-1.4 6.3.2 9.1 1.1 1.1 3 1.8 5.6 1.9Z"
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.6"
      />
    ),
    dairy: (
      <>
        <path d="M9 6h6l1.4 3.2v7.9A2 2 0 0 1 14.4 19H9.6A2 2 0 0 1 7.6 17.1V9.2L9 6Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.7" />
        <path d="M9 6V4.8h6V6" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.7" />
      </>
    ),
    bakery: (
      <path d="M5.4 13.2c0-4.3 3-7.2 6.6-7.2s6.6 2.9 6.6 7.2c0 2.9-2.1 5.4-4.9 5.4H10.3c-2.8 0-4.9-2.5-4.9-5.4Z" fill="none" stroke="currentColor" strokeWidth="1.7" />
    ),
    meat: (
      <path d="M8.2 13.6c0-3.5 2.7-5.8 5.8-5.8 2.7 0 4.5 1.6 4.5 4.2 0 3.6-3.5 8-8.3 8-2 0-3.3-1.4-3.3-3.1 0-1.4.7-2.7 1.3-3.3Z" fill="none" stroke="currentColor" strokeWidth="1.7" />
    ),
    pantry: (
      <>
        <rect x="7.6" y="7" width="8.8" height="12" rx="2.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
        <path d="M9.2 7V5.5h5.6V7" fill="none" stroke="currentColor" strokeWidth="1.7" />
      </>
    ),
    beverages: (
      <>
        <path d="M11 4.8h2v3l2.7 4v6a2.2 2.2 0 0 1-2.2 2.2h-3A2.2 2.2 0 0 1 8.3 17.8v-6l2.7-4v-3Z" fill="none" stroke="currentColor" strokeWidth="1.7" />
      </>
    ),
    frozen: (
      <>
        <path d="m12 4.6 1.3 2.5 2.8-.1-1.9 2 1.1 2.5-2.5-1.3-2.5 1.3 1.1-2.5-1.9-2 2.8.1L12 4.6Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.6" />
        <path d="m12 12.1 1.3 2.5 2.8-.1-1.9 2 1.1 2.5-2.5-1.3-2.5 1.3 1.1-2.5-1.9-2 2.8.1 1.3-2.5Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.6" />
      </>
    ),
    store: (
      <>
        <path d="M5.5 9.3 7 5h10l1.5 4.3M6.8 9.3h10.4V19H6.8V9.3Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.7" />
        <path d="M10 13.5h4" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.7" />
      </>
    ),
    delivery: (
      <>
        <path d="M5.5 8h8.2v7.5H5.5V8Zm8.2 2.2h2.4L18 12v3.5h-4.3" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.7" />
        <circle cx="8.2" cy="17.2" r="1.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="15.8" cy="17.2" r="1.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
      </>
    ),
  };

  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      {icons[name] || icons.store}
    </svg>
  );
}

const navigationItems = [
  { id: "home", label: "Home" },
  { id: "categories", label: "Categories" },
  { id: "cart", label: "Cart" },
  { id: "orders", label: "Orders" },
  { id: "profile", label: "Profile" },
];

const shopperSectionTitles = {
  home: "Fresh picks",
  categories: "Browse aisles",
  cart: "Your basket",
  orders: "Recent orders",
  profile: "Your account",
};

const fallbackProductImage =
  "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1200&q=80";

const shopperDescriptions = {
  "2% Milk": "Fresh dairy staple for breakfast, coffee, and everyday cooking.",
  "Sourdough Bread": "Fresh-baked loaf with a crisp crust and soft centre.",
  "Fresh Strawberries": "Sweet berries packed and ready for snacks, desserts, or breakfast.",
  "Potato Chips": "Classic crunchy snack for lunch boxes, movie nights, and quick cravings.",
  "Ground Coffee": "Smooth everyday roast for home brewing and morning routines.",
  "Greek Yogurt": "Creamy protein-rich yogurt for breakfast bowls and light snacks.",
  "Sparkling Water 12-Pack": "Refreshing flavored sparkling water for easy fridge stocking.",
  "Baby Spinach": "Ready-to-use leafy greens for salads, wraps, and smoothies.",
  "Bananas": "Everyday fruit pick for breakfast, snacks, and lunch bags.",
  "Brown Eggs 12-Pack": "Family-size egg carton for breakfasts, baking, and meal prep.",
  "Cheddar Cheese Block": "Sharp cheddar for sandwiches, snacks, and home cooking.",
  "Chicken Breast Pack": "Fresh boneless chicken for dinners, grilling, and meal prep.",
  "Orange Juice": "Chilled breakfast juice with a bright citrus taste.",
  "Basmati Rice": "Kitchen staple for everyday meals and batch cooking.",
  "Tomatoes on the Vine": "Fresh produce item ideal for salads, sandwiches, and cooking.",
  "Frozen Pizza": "Quick freezer meal for easy lunches and weeknight dinners.",
};

const posterThemes = {
  Dairy: { base: "#f3f7ff", accent: "#7ca6ff", ink: "#1d4fd7" },
  Pantry: { base: "#f6f3ff", accent: "#b395ff", ink: "#5e35b1" },
  Beverages: { base: "#eefbff", accent: "#76d6ff", ink: "#0077b6" },
  Produce: { base: "#effaf1", accent: "#87d68d", ink: "#16733b" },
  Bakery: { base: "#fff6ec", accent: "#f3c27b", ink: "#a15c00" },
  Meat: { base: "#fff1f0", accent: "#ff9f9b", ink: "#b3261e" },
  Frozen: { base: "#eef6ff", accent: "#9ec7ff", ink: "#265dbe" },
  Household: { base: "#f4f6fb", accent: "#aab6d3", ink: "#43506d" },
  "Personal Care": { base: "#fff2fb", accent: "#f0a4d9", ink: "#a03b7a" },
  Groceries: { base: "#eff4ff", accent: "#b3c5ff", ink: "#0050cb" },
};

function getPosterGraphic(category, ink) {
  switch (category) {
    case "Dairy":
      return `
        <path d="M358 250h150l34 72v265c0 20-16 36-36 36H394c-20 0-36-16-36-36V250Z" fill="${ink}" opacity="0.94"/>
        <path d="M392 210h114l18 40H374l18-40Z" fill="${ink}" opacity="0.7"/>
        <rect x="402" y="374" width="96" height="110" rx="18" fill="#ffffff" opacity="0.92"/>
      `;
    case "Pantry":
      return `
        <rect x="316" y="248" width="268" height="360" rx="64" fill="${ink}" opacity="0.94"/>
        <rect x="364" y="194" width="172" height="72" rx="28" fill="${ink}" opacity="0.75"/>
        <rect x="372" y="346" width="156" height="150" rx="26" fill="#ffffff" opacity="0.92"/>
      `;
    case "Beverages":
      return `
        <path d="M440 164h56v64l42 62v280c0 30-24 54-54 54h-72c-30 0-54-24-54-54V290l42-62v-64Z" fill="${ink}" opacity="0.94"/>
        <rect x="390" y="346" width="156" height="132" rx="34" fill="#ffffff" opacity="0.92"/>
      `;
    case "Produce":
      return `
        <ellipse cx="450" cy="406" rx="144" ry="164" fill="${ink}" opacity="0.94"/>
        <path d="M446 228c36-52 86-66 130-46-20 54-68 84-130 94-12-14-14-28 0-48Z" fill="${ink}" opacity="0.72"/>
        <path d="M364 294c38 0 76 22 98 58-42 18-96 8-132-28 8-18 18-30 34-30Z" fill="#ffffff" opacity="0.22"/>
      `;
    case "Bakery":
      return `
        <path d="M260 462c0-112 86-184 190-184 114 0 190 78 190 184 0 82-54 148-126 148H386c-72 0-126-66-126-148Z" fill="${ink}" opacity="0.94"/>
        <path d="M356 336c24-24 50-36 94-36 42 0 70 12 94 36" fill="none" stroke="#ffffff" stroke-width="22" stroke-linecap="round" opacity="0.78"/>
      `;
    case "Meat":
      return `
        <path d="M326 404c0-96 72-158 160-158 78 0 130 44 130 116 0 96-94 228-228 228-56 0-92-38-92-86 0-38 22-78 30-100Z" fill="${ink}" opacity="0.94"/>
        <circle cx="500" cy="392" r="38" fill="#ffffff" opacity="0.9"/>
      `;
    case "Frozen":
      return `
        <rect x="292" y="286" width="316" height="276" rx="72" fill="${ink}" opacity="0.94"/>
        <path d="M382 286c8-46 42-72 68-72h0c28 0 60 24 68 72" fill="none" stroke="${ink}" stroke-width="28" stroke-linecap="round" opacity="0.8"/>
        <path d="M450 334l20 44 48 4-36 30 12 48-44-24-44 24 12-48-36-30 48-4 20-44Z" fill="#ffffff" opacity="0.92"/>
      `;
    case "Household":
      return `
        <path d="M404 194h92v74l52 34v266c0 34-28 62-62 62H414c-34 0-62-28-62-62V302l52-34v-74Z" fill="${ink}" opacity="0.94"/>
        <rect x="372" y="358" width="156" height="134" rx="28" fill="#ffffff" opacity="0.92"/>
      `;
    case "Personal Care":
      return `
        <rect x="336" y="188" width="228" height="434" rx="92" fill="${ink}" opacity="0.94"/>
        <rect x="396" y="148" width="108" height="64" rx="20" fill="${ink}" opacity="0.75"/>
        <rect x="384" y="350" width="132" height="150" rx="32" fill="#ffffff" opacity="0.92"/>
      `;
    default:
      return `
        <rect x="310" y="226" width="280" height="398" rx="84" fill="${ink}" opacity="0.94"/>
        <rect x="364" y="174" width="172" height="80" rx="28" fill="${ink}" opacity="0.78"/>
        <circle cx="450" cy="412" r="76" fill="#ffffff" opacity="0.92"/>
      `;
  }
}

function createProductPoster(name, category) {
  const theme = posterThemes[category] || posterThemes.Groceries;
  const categoryLabel = category || "Groceries";
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="900" height="900" viewBox="0 0 900 900">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${theme.base}"/>
          <stop offset="100%" stop-color="#ffffff"/>
        </linearGradient>
      </defs>
      <rect width="900" height="900" rx="54" fill="url(#g)"/>
      <circle cx="712" cy="174" r="118" fill="${theme.accent}" opacity="0.22"/>
      <circle cx="198" cy="712" r="138" fill="${theme.accent}" opacity="0.16"/>
      <rect x="82" y="82" width="736" height="736" rx="46" fill="#ffffff" opacity="0.56"/>
      ${getPosterGraphic(categoryLabel, theme.ink)}
      <text x="112" y="126" font-family="Inter, Arial, sans-serif" font-size="28" font-weight="700" fill="${theme.ink}" opacity="0.82">INTELLIGROCER SELECT</text>
      <text x="112" y="792" font-family="Inter, Arial, sans-serif" font-size="34" font-weight="700" fill="${theme.ink}" opacity="0.88">${categoryLabel.toUpperCase()}</text>
    </svg>`;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

const productImageOverrides = {
  "2% Milk": createProductPoster("2% Milk", "Dairy"),
  "Orange Juice": createProductPoster("Orange Juice", "Beverages"),
  "Peanut Butter": createProductPoster("Peanut Butter", "Pantry"),
  "Basmati Rice": createProductPoster("Basmati Rice", "Pantry"),
  "Sparkling Water 12-Pack": createProductPoster("Sparkling Water", "Beverages"),
  "Brown Eggs 12-Pack": createProductPoster("Brown Eggs", "Dairy"),
  "Ground Coffee": createProductPoster("Ground Coffee", "Pantry"),
  "Paper Towels": createProductPoster("Paper Towels", "Household"),
  Shampoo: createProductPoster("Shampoo", "Personal Care"),
  "Spaghetti Pasta": createProductPoster("Spaghetti Pasta", "Pantry"),
  "Vanilla Ice Cream": createProductPoster("Vanilla Ice Cream", "Frozen"),
  "Laundry Detergent": createProductPoster("Laundry Detergent", "Household"),
  "Rolled Oats": createProductPoster("Rolled Oats", "Pantry"),
};

function getCategoryIconName(category) {
  const map = {
    Produce: "produce",
    Dairy: "dairy",
    Bakery: "bakery",
    Meat: "meat",
    Pantry: "pantry",
    Beverages: "beverages",
    Frozen: "frozen",
  };

  return map[category] || "store";
}

function getProductTag(product) {
  if (isOnSale(product)) {
    return product.promotionLabel || `${getDiscountPercent(product)}% Off`;
  }

  const stockLevel = Number(product.stockLevel || 0);
  if (stockLevel >= 40) {
    return "Popular";
  }

  return product.category || "Featured";
}

function getShopperDescription(product) {
  if (shopperDescriptions[product.name]) {
    return shopperDescriptions[product.name];
  }

  return product.category
    ? `${product.category} item available in the current IntelliGrocer catalog.`
    : "Available now in the current IntelliGrocer catalog.";
}

function getOfferTag(product) {
  if (isOnSale(product)) {
    return product.promotionLabel || "Store offer";
  }

  const salesTrend = Number(product.salesTrend || 0);

  if (salesTrend >= 75) {
    return "Popular now";
  }

  return product.category || "Featured";
}

function getProductImageSrc(product) {
  return product.image || productImageOverrides[product.name] || createProductPoster(product.name, product.category || "Groceries");
}

function getDisplayPrice(product) {
  return Number(product?.basePrice || 0);
}

function getCompareAtPrice(product) {
  return Number(product?.compareAtPrice || 0);
}

function isOnSale(product) {
  return getCompareAtPrice(product) > getDisplayPrice(product);
}

function getDiscountPercent(product) {
  const displayPrice = getDisplayPrice(product);
  const compareAtPrice = getCompareAtPrice(product);

  if (!displayPrice || compareAtPrice <= displayPrice) {
    return 0;
  }

  return Math.round(((compareAtPrice - displayPrice) / compareAtPrice) * 100);
}

function getProductGallery(product) {
  const primaryImage = getProductImageSrc(product);
  const gallery = [primaryImage, ...(product.images || []).filter((image) => image && image !== primaryImage)];
  return [...new Set(gallery)];
}

function getProductFallbackImage(product) {
  return productImageOverrides[product.name] || createProductPoster(product.name, product.category || "Groceries");
}

function CustomerDashboard({ onLogout }) {
  const [activeSection, setActiveSection] = useState("home");
  const [username, setUsername] = useState(localStorage.getItem("username") || "Guest");
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [phone, setPhone] = useState(localStorage.getItem("phone") || "");
  const [address, setAddress] = useState(localStorage.getItem("address") || "");
  const [role, setRole] = useState(localStorage.getItem("role") || "");
  const [inventory, setInventory] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [cart, setCart] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [profileSuccess, setProfileSuccess] = useState("");
  const [profileError, setProfileError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductImage, setSelectedProductImage] = useState(0);
  const [selectedProductQuantity, setSelectedProductQuantity] = useState(1);
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    setUsername(localStorage.getItem("username") || "Guest");
    setEmail(localStorage.getItem("email") || "");
    setPhone(localStorage.getItem("phone") || "");
    setAddress(localStorage.getItem("address") || "");
    setRole(localStorage.getItem("role") || "");
  }, []);

  const fetchInventory = useCallback(async () => {
    try {
      const response = await axios.get(apiUrl("/api/inventory"));
      setInventory(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching inventory:", error);
      setInventory([]);
    }
  }, []);

  const fetchOrderHistory = useCallback(async () => {
    if (!userId) {
      setOrderHistory([]);
      return;
    }

    try {
      const response = await axios.get(apiUrl(`/api/orders/user/${userId}`));
      setOrderHistory(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching order history:", error.response?.data || error.message);
      setOrderHistory([]);
    }
  }, [userId]);

  useEffect(() => {
    fetchInventory();
    fetchOrderHistory();
  }, [fetchInventory, fetchOrderHistory]);

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 550,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3400,
    pauseOnHover: true,
  };

  const categorySummary = useMemo(() => {
    const summary = new Map();

    inventory.forEach((item) => {
      const category = item.category || "Store Picks";
      summary.set(category, (summary.get(category) || 0) + 1);
    });

    return [["All", inventory.length], ...Array.from(summary.entries())];
  }, [inventory]);

  const filteredInventory = useMemo(() => {
    return inventory.filter((product) => {
      const matchesSearch =
        !searchTerm ||
        [product.name, product.description]
          .filter(Boolean)
          .some((value) => value.toLowerCase().includes(searchTerm.toLowerCase()));

      const productCategory = product.category || "Store Picks";
      const matchesCategory = selectedCategory === "All" || productCategory === selectedCategory;

      return matchesSearch && matchesCategory;
    });
  }, [inventory, searchTerm, selectedCategory]);

  const cartItemCount = useMemo(
    () => cart.reduce((total, item) => total + (item.quantity || 1), 0),
    [cart],
  );

  const cartTotal = useMemo(
    () =>
      cart.reduce(
        (total, item) => total + getDisplayPrice(item) * (item.quantity || 1),
        0,
      ),
    [cart],
  );

  const latestOrder = orderHistory[0];
  const cartTax = useMemo(() => cartTotal * 0.13, [cartTotal]);
  const estimatedCartTotal = useMemo(() => cartTotal + cartTax, [cartTax, cartTotal]);

  const featuredOffers = useMemo(() => {
    return inventory
      .filter((product) => getProductImageSrc(product))
      .sort((left, right) => {
        const leftScore =
          (isOnSale(left) ? 120 : 0) + Number(left.salesTrend || 0) + Number(left.stockLevel || 0) / 4;
        const rightScore =
          (isOnSale(right) ? 120 : 0) + Number(right.salesTrend || 0) + Number(right.stockLevel || 0) / 4;
        return rightScore - leftScore;
      })
      .slice(0, 3);
  }, [inventory]);

  const recommendedProducts = useMemo(() => {
    const cartIds = new Set(cart.map((item) => item._id));
    return inventory.filter((item) => !cartIds.has(item._id)).slice(0, 4);
  }, [inventory, cart]);

  const essentialsProducts = useMemo(() => {
    const priorityCategories = ["Produce", "Dairy", "Bakery", "Pantry", "Beverages"];
    return inventory
      .filter((item) => priorityCategories.includes(item.category))
      .sort((left, right) => Number(right.salesTrend || 0) - Number(left.salesTrend || 0))
      .slice(0, 6);
  }, [inventory]);

  const categoryHighlights = useMemo(() => {
    return categorySummary
      .filter(([category]) => category !== "All")
      .map(([category, count]) => {
        const leadProduct = inventory
          .filter((item) => (item.category || "Store Picks") === category)
          .sort((left, right) => Number(right.salesTrend || 0) - Number(left.salesTrend || 0))[0];

        return { category, count, leadProduct };
      })
      .filter((entry) => entry.leadProduct)
      .slice(0, 4);
  }, [categorySummary, inventory]);

  const relatedProducts = useMemo(() => {
    if (!selectedProduct) {
      return [];
    }

    return inventory
      .filter(
        (item) =>
          item._id !== selectedProduct._id &&
          (item.category === selectedProduct.category || item.department === selectedProduct.department),
      )
      .slice(0, 4);
  }, [inventory, selectedProduct]);

  const shopperSectionTitle =
    activeSection === "product" && selectedProduct
      ? selectedProduct.name
      : shopperSectionTitles[activeSection] || "Fresh picks";

  const selectedProductGallery = useMemo(
    () => (selectedProduct ? getProductGallery(selectedProduct) : []),
    [selectedProduct],
  );

  const selectedProductInCart = useMemo(
    () => cart.find((item) => item._id === selectedProduct?._id),
    [cart, selectedProduct],
  );

  const addToCart = (item) => {
    const quantityToAdd = item.quantityToAdd || 1;
    setCart((previousCart) => {
      const existingItem = previousCart.find((entry) => entry._id === item._id);
      if (existingItem) {
        return previousCart.map((entry) =>
          entry._id === item._id
            ? { ...entry, quantity: (entry.quantity || 1) + quantityToAdd }
            : entry,
        );
      }

      return [...previousCart, { ...item, quantity: quantityToAdd }];
    });
  };

  const handleImageFallback = (event, product) => {
    const productFallback = product ? getProductFallbackImage(product) : fallbackProductImage;

    if (event.currentTarget.src !== productFallback) {
      event.currentTarget.src = productFallback;
      return;
    }

    if (event.currentTarget.src !== fallbackProductImage) {
      event.currentTarget.src = fallbackProductImage;
    }
  };

  const removeFromCart = (itemId) => {
    setCart((previousCart) =>
      previousCart
        .map((item) =>
          item._id === itemId ? { ...item, quantity: item.quantity - 1 } : item,
        )
        .filter((item) => item.quantity > 0),
    );
  };

  const setCartQuantity = (itemId, nextQuantity) => {
    if (nextQuantity <= 0) {
      removeFromCart(itemId);
      return;
    }

    setCart((previousCart) =>
      previousCart.map((item) => (item._id === itemId ? { ...item, quantity: nextQuantity } : item)),
    );
  };

  const clearCart = () => setCart([]);

  const addOrderToCart = (order) => {
    const itemsToAdd = order.items
      .map(({ itemId, quantity }) => {
        const itemName = typeof itemId === "object" ? itemId?.name : null;
        const itemKey = typeof itemId === "object" ? itemId?._id : itemId;
        const match = inventory.find((product) => product._id === itemKey || product.name === itemName);

        return match ? { ...match, quantityToAdd: quantity || 1 } : null;
      })
      .filter(Boolean);

    if (!itemsToAdd.length) {
      return;
    }

    setCart((previousCart) => {
      const nextCart = [...previousCart];

      itemsToAdd.forEach((product) => {
        const existingIndex = nextCart.findIndex((entry) => entry._id === product._id);

        if (existingIndex >= 0) {
          nextCart[existingIndex] = {
            ...nextCart[existingIndex],
            quantity: (nextCart[existingIndex].quantity || 1) + (product.quantityToAdd || 1),
          };
        } else {
          nextCart.push({ ...product, quantity: product.quantityToAdd || 1 });
        }
      });

      return nextCart;
    });

    setActiveSection("cart");
  };

  const handlePurchase = async () => {
    if (cart.length === 0) {
      alert("Your cart is empty.");
      return;
    }

    const totalRevenue = cart.reduce(
      (total, item) => total + getDisplayPrice(item) * (item.quantity || 1),
      0,
    );

    try {
      await axios.post(apiUrl("/api/orders"), {
        userId,
        items: cart.map((item) => ({
          itemId: item._id,
          quantity: item.quantity || 1,
        })),
      });

      try {
      await axios.post(apiUrl("/api/sales/update"), { totalRevenue });
      } catch (salesError) {
        console.error("Error updating sales after order:", salesError.response?.data || salesError.message);
      }

      await fetchInventory();
      await fetchOrderHistory();
      setCart([]);
      setActiveSection("orders");
    } catch (error) {
      console.error("Error processing purchase:", error);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Error processing purchase";
      alert(message);
      await fetchInventory();
    }
  };

  const validatePhone = (value) => /^[0-9]{10}$/.test(value);

  const saveProfile = async () => {
    if (!validatePhone(phone)) {
      setProfileError("Please enter a valid 10-digit phone number.");
      setTimeout(() => setProfileError(""), 3000);
      return;
    }

    try {
      await axios.patch(apiUrl("/api/auth/update"), {
        userId,
        username,
        email,
        phone,
        address,
        role,
      });

      localStorage.setItem("username", username);
      localStorage.setItem("email", email);
      localStorage.setItem("phone", phone);
      localStorage.setItem("address", address);
      localStorage.setItem("role", role);
      setIsEditing(false);
      setProfileSuccess("Changes saved successfully.");
      setProfileError("");
      setTimeout(() => setProfileSuccess(""), 3000);
    } catch (error) {
      console.error("Error updating profile:", error);
      setProfileError("Error updating profile. Please try again.");
      setTimeout(() => setProfileError(""), 3000);
    }
  };

  const handleLogout = () => {
    if (typeof onLogout === "function") {
      onLogout();
      return;
    }

    ["token", "userId", "employeeId", "username", "email", "phone", "address", "role"].forEach((key) =>
      localStorage.removeItem(key),
    );
    navigate("/");
  };

  const handleOfferClick = (product) => {
    setActiveSection("home");
    setSelectedCategory(product.category || "All");
    setSearchTerm("");

    window.requestAnimationFrame(() => {
      const section = document.getElementById("shopper-products");
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  };

  const openProduct = (product) => {
    setSelectedProduct(product);
    setSelectedProductImage(0);
    setSelectedProductQuantity(1);
    setActiveSection("product");
  };

  return (
    <div className="customer-dashboard">
      <header className="shopper-topbar">
        <div className="shopper-topbar__brand">
          <button type="button" className="shopper-icon-button shopper-icon-button--menu" aria-label="Open menu">
            <ShopperIcon name="menu" />
          </button>
          <span className="shopper-topbar__mark">IG</span>
          <div>
            <p className="shopper-topbar__eyebrow">IntelliGrocer</p>
            <h1>{shopperSectionTitle}</h1>
          </div>
        </div>

        <div className="shopper-topbar__actions">
          <button type="button" className="shopper-icon-button" aria-label="View orders" onClick={() => setActiveSection("orders")}>
            <ShopperIcon name="bell" />
          </button>
          <button type="button" className="shopper-bag-button" onClick={() => setActiveSection("cart")}>
            <ShopperIcon name="cart" className="shopper-bag-button__icon" />
            <span className="shopper-bag-button__label">Cart</span>
            <span>{cartItemCount}</span>
          </button>
          <div className="shopper-avatar" aria-hidden="true">
            <span>{(username || "S").charAt(0).toUpperCase()}</span>
          </div>
        </div>
      </header>

      <main className="shopper-main">
        {activeSection === "home" && (
          <>
            <section className="shopper-search-panel">
              <div className="shopper-search-input">
                <span className="shopper-search-input__icon">
                  <ShopperIcon name="search" />
                </span>
                <input
                  type="text"
                  placeholder="Search fresh produce, dairy, and pantry items"
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                />
              </div>
            </section>

            {featuredOffers.length ? (
              <section className="shopper-section">
                <div className="shopper-section__heading">
                  <div>
                    <p className="shopper-label">Featured deals</p>
                    <h2>Current offers</h2>
                  </div>
                  <button type="button" className="shopper-text-button" onClick={() => setActiveSection("categories")}>
                    Browse more
                  </button>
                </div>

                <div className="shopper-banner-slider">
                  <Slider {...sliderSettings}>
                    {featuredOffers.map((product) => (
                      <article key={product._id} className="shopper-banner-card">
                        <img
                          src={getProductImageSrc(product)}
                          alt={product.name}
                          onError={(event) => handleImageFallback(event, product)}
                        />
                        <div className="shopper-banner-card__overlay">
                          <span>{getOfferTag(product)}</span>
                          <h3>{product.name}</h3>
                          <p className="shopper-banner-card__price">
                            ${getDisplayPrice(product).toFixed(2)}
                            {isOnSale(product) ? ` from $${getCompareAtPrice(product).toFixed(2)}` : ""}
                          </p>
                          <button type="button" onClick={() => handleOfferClick(product)}>
                            View item
                          </button>
                        </div>
                      </article>
                    ))}
                  </Slider>
                </div>
              </section>
            ) : null}

            <section className="shopper-section" id="shopper-products">
              <div className="shopper-section__heading">
                <div>
                  <p className="shopper-label">Shop by category</p>
                  <h2>Browse the aisle</h2>
                </div>
              </div>

              <div className="shopper-category-strip">
                {categorySummary.map(([category]) => (
                  <button
                    key={category}
                    type="button"
                    className={`shopper-category-pill ${selectedCategory === category ? "active" : ""}`}
                    onClick={() => {
                      setSelectedCategory(category);
                      setActiveSection("home");
                    }}
                  >
                    <span>
                      <ShopperIcon name={category === "All" ? "store" : getCategoryIconName(category)} />
                    </span>
                    <strong>{category}</strong>
                  </button>
                ))}
              </div>
            </section>

            <section className="shopper-section">
              <div className="shopper-section__heading">
                <div>
                  <p className="shopper-label">Product feed</p>
                  <h2>Popular items</h2>
                </div>
                <span className="shopper-section__count">{filteredInventory.length} items</span>
              </div>

              <div className="shopper-product-grid">
                {filteredInventory.length ? (
                  filteredInventory.map((product) => (
                    <article key={product._id} className="shopper-product-card">
                      <button
                        type="button"
                        className="shopper-product-card__media shopper-product-card__media-button"
                        onClick={() => openProduct(product)}
                      >
                          <img
                            src={getProductImageSrc(product)}
                            alt={product.name}
                            onError={(event) => handleImageFallback(event, product)}
                          />
                          <span className="shopper-product-card__badge">{getProductTag(product)}</span>
                      </button>
                      <div className="shopper-product-card__body">
                        <h3>{product.name}</h3>
                        <p>{product.description || getShopperDescription(product)}</p>
                        <div className="shopper-product-card__meta">
                          <div className="shopper-price-stack">
                            <strong>${getDisplayPrice(product).toFixed(2)}</strong>
                            {isOnSale(product) ? (
                              <span className="shopper-compare-price">${getCompareAtPrice(product).toFixed(2)}</span>
                            ) : null}
                          </div>
                          <span>{product.category || "Store Picks"}</span>
                        </div>
                        <button type="button" className="shopper-product-card__action" onClick={() => addToCart(product)}>
                          Add to Cart
                        </button>
                      </div>
                    </article>
                  ))
                ) : (
                  <div className="shopper-empty-card">
                    <h3>No matching products</h3>
                    <p>Try another search or switch back to all categories.</p>
                  </div>
                )}
              </div>
            </section>

            {latestOrder ? (
              <section className="shopper-order-insight">
                <div>
                  <p className="shopper-label">Last order status</p>
                  <h2>Recent order available</h2>
                  <p>Placed on {new Date(latestOrder.createdAt).toLocaleString()}.</p>
                  <button type="button" className="shopper-text-button" onClick={() => setActiveSection("orders")}>
                    View order history
                  </button>
                </div>
                <div className="shopper-order-insight__badge">
                  <ShopperIcon name="delivery" />
                </div>
              </section>
            ) : null}
          </>
        )}

        {activeSection === "categories" && (
          <section className="shopper-section shopper-panel shopper-panel--page">
            <div className="shopper-section__heading">
              <div>
                <p className="shopper-label">Categories</p>
                <h2>Category overview</h2>
              </div>
            </div>

            <div className="shopper-category-grid">
              {categorySummary.map(([category, count]) => (
                <button
                  key={category}
                  type="button"
                  className={`shopper-category-card ${selectedCategory === category ? "active" : ""}`}
                  onClick={() => {
                    setSelectedCategory(category);
                    setActiveSection("home");
                  }}
                >
                  <span>
                    <ShopperIcon name={category === "All" ? "store" : getCategoryIconName(category)} />
                  </span>
                  <strong>{category}</strong>
                  <p>{count} items</p>
                </button>
              ))}
            </div>

            <div className="shopper-info-grid">
              <article className="shopper-info-card">
                <h3>Popular departments</h3>
                <p>Produce, Dairy, Pantry, and Bakery are the busiest parts of the catalog right now.</p>
              </article>
              <article className="shopper-info-card">
                <h3>Quick tip</h3>
                <p>Select a category to jump back to the home feed with only those products visible.</p>
              </article>
            </div>

            <div className="shopper-category-showcase">
              {categoryHighlights.map(({ category, count, leadProduct }) => (
                <article key={category} className="shopper-category-showcase__card">
                  <img
                    src={getProductImageSrc(leadProduct)}
                    alt={leadProduct.name}
                    onError={(event) => handleImageFallback(event, leadProduct)}
                  />
                  <div>
                    <p className="shopper-label">{category}</p>
                    <h3>{leadProduct.name}</h3>
                    <p>{count} items available in this aisle right now.</p>
                  </div>
                  <button
                    type="button"
                    className="shopper-text-button"
                    onClick={() => {
                      setSelectedCategory(category);
                      setActiveSection("home");
                    }}
                  >
                    View {category.toLowerCase()}
                  </button>
                </article>
              ))}
            </div>

            <div className="shopper-mini-product-row shopper-mini-product-row--wide">
              {recommendedProducts.map((product) => (
                <button key={product._id} type="button" className="shopper-mini-product" onClick={() => openProduct(product)}>
                  <img
                    src={getProductImageSrc(product)}
                    alt={product.name}
                    onError={(event) => handleImageFallback(event, product)}
                  />
                  <strong>{product.name}</strong>
                  <span className="shopper-mini-product__meta">${getDisplayPrice(product).toFixed(2)}</span>
                </button>
              ))}
            </div>
          </section>
        )}

        {activeSection === "cart" && (
          <section className="shopper-section shopper-panel shopper-panel--page">
            <div className="shopper-section__heading">
              <div>
                <p className="shopper-label">Cart</p>
                <h2>Current basket</h2>
              </div>
              <span className="shopper-section__count">{cartItemCount} items</span>
            </div>

            {cart.length ? (
              <>
                <div className="shopper-cart-toolbar">
                  <button type="button" className="shopper-secondary-button" onClick={() => setActiveSection("home")}>
                    Continue shopping
                  </button>
                  <button type="button" className="shopper-secondary-button shopper-secondary-button--danger" onClick={clearCart}>
                    Clear cart
                  </button>
                </div>
                <div className="shopper-cart-list">
                  {cart.map((item) => (
                    <div key={item._id} className="shopper-cart-item">
                      <div className="shopper-cart-item__main">
                        <img
                          className="shopper-cart-item__image"
                          src={getProductImageSrc(item)}
                          alt={item.name}
                          onError={(event) => handleImageFallback(event, item)}
                        />
                        <div>
                          <strong>{item.name}</strong>
              <p>${getDisplayPrice(item).toFixed(2)} each</p>
                        </div>
                      </div>
                      <div className="shopper-cart-item__actions">
                        <div className="shopper-quantity-control">
                          <button type="button" onClick={() => setCartQuantity(item._id, (item.quantity || 1) - 1)}>
                            -
                          </button>
                          <span>{item.quantity || 1}</span>
                          <button type="button" onClick={() => setCartQuantity(item._id, (item.quantity || 1) + 1)}>
                            +
                          </button>
                        </div>
                        <div className="shopper-cart-item__summary">
              <strong>${(getDisplayPrice(item) * (item.quantity || 1)).toFixed(2)}</strong>
                          <button type="button" onClick={() => removeFromCart(item._id)}>
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="shopper-cart-total">
                  <div className="shopper-cart-total__breakdown">
                    <div>
                      <span>Subtotal</span>
                      <strong>${cartTotal.toFixed(2)}</strong>
                    </div>
                    <div>
                      <span>Estimated Tax</span>
                      <strong>${cartTax.toFixed(2)}</strong>
                    </div>
                    <div>
                      <span>Estimated Total</span>
                      <strong>${estimatedCartTotal.toFixed(2)}</strong>
                    </div>
                  </div>
                  <button type="button" onClick={handlePurchase}>
                    Place Order
                  </button>
                </div>
                <div className="shopper-info-grid">
                  <article className="shopper-info-card">
                    <h3>Checkout snapshot</h3>
                    <p>Your basket has {cartItemCount} item{cartItemCount === 1 ? "" : "s"} and is ready whenever you are.</p>
                  </article>
                  <article className="shopper-info-card">
                    <h3>Add one more</h3>
                    <p>Recommended items below are pulled from the rest of your catalog so the basket feels active and useful.</p>
                  </article>
                </div>
                <div className="shopper-mini-product-row shopper-mini-product-row--wide">
                    {recommendedProducts.map((product) => (
                      <button key={product._id} type="button" className="shopper-mini-product" onClick={() => openProduct(product)}>
                        <img
                          src={getProductImageSrc(product)}
                          alt={product.name}
                          onError={(event) => handleImageFallback(event, product)}
                        />
                        <strong>{product.name}</strong>
                        <span className="shopper-mini-product__meta">${getDisplayPrice(product).toFixed(2)}</span>
                      </button>
                    ))}
                </div>
              </>
            ) : (
              <>
                <div className="shopper-empty-card">
                  <h3>Your cart is empty</h3>
                  <p>Add a few products to continue with checkout.</p>
                </div>
                <div className="shopper-info-grid">
                  <article className="shopper-info-card">
                    <h3>Start with essentials</h3>
                    <p>Build a basket quickly with a few everyday grocery picks from produce, dairy, bakery, and pantry.</p>
                  </article>
                  <article className="shopper-info-card">
                    <h3>Quick shop</h3>
                    <p>Open any product to see its details, adjust quantity, and add it straight into your basket.</p>
                  </article>
                </div>
                <div className="shopper-cart-builder">
                  {essentialsProducts.map((product) => (
                    <article key={product._id} className="shopper-cart-builder__card">
                      <img
                        src={getProductImageSrc(product)}
                        alt={product.name}
                        onError={(event) => handleImageFallback(event, product)}
                      />
                      <div>
                        <p className="shopper-label">{product.category || "Store Picks"}</p>
                        <h3>{product.name}</h3>
            <div className="shopper-price-stack shopper-price-stack--product">
              <strong>${getDisplayPrice(product).toFixed(2)}</strong>
              {isOnSale(product) ? <span className="shopper-compare-price">${getCompareAtPrice(product).toFixed(2)}</span> : null}
            </div>
                      </div>
                      <button type="button" className="shopper-secondary-button" onClick={() => addToCart(product)}>
                        Add
                      </button>
                    </article>
                  ))}
                </div>
              </>
            )}
          </section>
        )}

        {activeSection === "orders" && (
          <section className="shopper-section shopper-panel shopper-panel--page">
            <div className="shopper-section__heading">
              <div>
                <p className="shopper-label">Orders</p>
                <h2>Recent orders</h2>
              </div>
              <span className="shopper-section__count">{orderHistory.length} orders</span>
            </div>

            {orderHistory.length ? (
              <>
                <div className="shopper-orders-list">
                  {orderHistory.map((order) => {
                  const grouped = {};
                  order.items.forEach(({ itemId, quantity }) => {
                    const name = itemId?.name || "Unknown";
                    grouped[name] = (grouped[name] || 0) + quantity;
                  });

                  return (
                    <article key={order._id} className="shopper-order-card">
                      <div className="shopper-order-card__header">
                        <div>
                          <span>Order ID</span>
                          <strong>{order._id}</strong>
                        </div>
                        <time>{new Date(order.createdAt).toLocaleString()}</time>
                      </div>
                      <div className="shopper-order-card__items">
                        {Object.entries(grouped).map(([name, quantity]) => (
                          <div key={`${order._id}-${name}`} className="shopper-order-card__item">
                            <span>{name}</span>
                            <strong>x{quantity}</strong>
                          </div>
                        ))}
                      </div>
                      <div className="shopper-order-card__actions">
                        <button type="button" className="shopper-secondary-button" onClick={() => addOrderToCart(order)}>
                          Add order again
                        </button>
                      </div>
                    </article>
                  );
                  })}
                </div>
                <div className="shopper-info-grid">
                  <article className="shopper-info-card">
                    <h3>Order summary</h3>
                    <p>You have placed {orderHistory.length} order{orderHistory.length === 1 ? "" : "s"} with this account.</p>
                  </article>
                  <article className="shopper-info-card">
                    <h3>Quick reorder</h3>
                    <p>Use the reorder button on any order card to bring those items back into your basket instantly.</p>
                  </article>
                </div>
                <div className="shopper-mini-product-row shopper-mini-product-row--wide">
                  {recommendedProducts.map((product) => (
                    <button key={product._id} type="button" className="shopper-mini-product" onClick={() => openProduct(product)}>
                      <img
                        src={getProductImageSrc(product)}
                        alt={product.name}
                        onError={(event) => handleImageFallback(event, product)}
                      />
                      <strong>{product.name}</strong>
            <span className="shopper-mini-product__meta">${getDisplayPrice(product).toFixed(2)}</span>
                    </button>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="shopper-empty-card">
                  <h3>No orders yet</h3>
                  <p>Your order history will appear here after checkout.</p>
                </div>
                <div className="shopper-info-grid">
                  <article className="shopper-info-card">
                    <h3>How orders show up</h3>
                    <p>Once you place an order from the cart, it will appear here with product quantities and the date.</p>
                  </article>
                  <article className="shopper-info-card">
                    <h3>Ready to shop</h3>
                    <p>Head back to the home feed to add products and create your first order.</p>
                  </article>
                </div>
                <div className="shopper-mini-product-row shopper-mini-product-row--wide">
                  {essentialsProducts.map((product) => (
                    <button key={product._id} type="button" className="shopper-mini-product" onClick={() => openProduct(product)}>
                      <img
                        src={getProductImageSrc(product)}
                        alt={product.name}
                        onError={(event) => handleImageFallback(event, product)}
                      />
                      <strong>{product.name}</strong>
           <span className="shopper-mini-product__meta">${getDisplayPrice(product).toFixed(2)}</span>
                    </button>
                  ))}
                </div>
              </>
            )}
          </section>
        )}

        {activeSection === "product" && selectedProduct ? (
          <section className="shopper-section shopper-panel shopper-product-page shopper-panel--page">
            <div className="shopper-section__heading">
              <div>
                <p className="shopper-label">Product details</p>
                <h2>{selectedProduct.name}</h2>
              </div>
              <button type="button" className="shopper-secondary-button" onClick={() => setActiveSection("home")}>
                Back to shopping
              </button>
            </div>

            <div className="shopper-product-page__layout">
              <div className="shopper-product-page__gallery">
                <img
                  src={selectedProductGallery[selectedProductImage] || getProductImageSrc(selectedProduct)}
                  alt={selectedProduct.name}
                  className="shopper-product-page__image"
                  onError={(event) => handleImageFallback(event, selectedProduct)}
                />
                {selectedProductGallery.length > 1 ? (
                  <div className="shopper-product-page__thumbs">
                    {selectedProductGallery.map((image, index) => (
                      <button
                        key={`${selectedProduct._id}-${index}`}
                        type="button"
                        className={selectedProductImage === index ? "active" : ""}
                        onClick={() => setSelectedProductImage(index)}
                      >
                        <img
                          src={image}
                          alt={`${selectedProduct.name} ${index + 1}`}
                          onError={(event) => handleImageFallback(event, selectedProduct)}
                        />
                      </button>
                    ))}
                  </div>
                ) : null}
              </div>

              <div className="shopper-product-page__content">
                <div className="shopper-product-page__top">
                  <div>
                    <span className="shopper-label">{selectedProduct.category || "Store Picks"}</span>
                    <p className="shopper-product-page__subhead">
                      {selectedProduct.brand || "IntelliGrocer"} • {selectedProduct.unit || "Standard pack"}
                    </p>
                    {isOnSale(selectedProduct) ? (
                      <p className="shopper-product-page__sale-tag">
                        {selectedProduct.promotionLabel || `${getDiscountPercent(selectedProduct)}% off`}
                      </p>
                    ) : null}
                  </div>
                  <div className="shopper-price-stack shopper-price-stack--product">
                    <strong>${getDisplayPrice(selectedProduct).toFixed(2)}</strong>
                    {isOnSale(selectedProduct) ? (
                      <span className="shopper-compare-price">${getCompareAtPrice(selectedProduct).toFixed(2)}</span>
                    ) : null}
                  </div>
                </div>
                <p className="shopper-product-page__description">
                  {selectedProduct.description || getShopperDescription(selectedProduct)}
                </p>

                <div className="shopper-product-page__facts">
                  <div>
                    <span>Brand</span>
                    <strong>{selectedProduct.brand || "IntelliGrocer"}</strong>
                  </div>
                  <div>
                    <span>Size</span>
                    <strong>{selectedProduct.unit || "Standard pack"}</strong>
                  </div>
                  <div>
                    <span>Department</span>
                    <strong>{selectedProduct.department || selectedProduct.category || "Store Picks"}</strong>
                  </div>
                </div>

                <div className="shopper-product-page__details">
                  <h3>Why shoppers pick this</h3>
                  <ul>
                    {(selectedProduct.highlights || []).length ? (
                      selectedProduct.highlights.map((highlight) => <li key={highlight}>{highlight}</li>)
                    ) : (
                      <li>{getShopperDescription(selectedProduct)}</li>
                    )}
                  </ul>
                </div>

                <div className="shopper-product-page__purchase">
                  <div className="shopper-quantity-control shopper-quantity-control--large">
                    <button type="button" onClick={() => setSelectedProductQuantity(Math.max(1, selectedProductQuantity - 1))}>
                      -
                    </button>
                    <span>{selectedProductQuantity}</span>
                    <button type="button" onClick={() => setSelectedProductQuantity(selectedProductQuantity + 1)}>
                      +
                    </button>
                  </div>
                  <div className="shopper-product-page__purchase-info">
                    <span>Estimated total</span>
                    <strong>${(getDisplayPrice(selectedProduct) * selectedProductQuantity).toFixed(2)}</strong>
                    {selectedProductInCart ? <em>{selectedProductInCart.quantity} already in your basket</em> : null}
                  </div>
                </div>

                <button
                  type="button"
                  className="shopper-product-page__action"
                  onClick={() => addToCart({ ...selectedProduct, quantityToAdd: selectedProductQuantity })}
                >
                  Add to Cart
                </button>
              </div>
            </div>

            {relatedProducts.length ? (
              <div className="shopper-product-page__related">
                <div className="shopper-section__heading">
                  <div>
                    <p className="shopper-label">You may also like</p>
                    <h2>Pair it with</h2>
                  </div>
                </div>
                <div className="shopper-mini-product-row shopper-mini-product-row--wide">
                  {relatedProducts.map((product) => (
                    <button key={product._id} type="button" className="shopper-mini-product" onClick={() => openProduct(product)}>
                      <img
                        src={getProductImageSrc(product)}
                        alt={product.name}
                        onError={(event) => handleImageFallback(event, product)}
                      />
                      <strong>{product.name}</strong>
           <span className="shopper-mini-product__meta">${getDisplayPrice(product).toFixed(2)}</span>
                    </button>
                  ))}
                </div>
              </div>
            ) : null}
          </section>
        ) : null}

        {activeSection === "profile" && (
          <section className="shopper-section shopper-panel">
            <div className="shopper-section__heading">
              <div>
                <p className="shopper-label">Profile</p>
                <h2>Account details</h2>
              </div>
              {!isEditing ? (
                <button type="button" className="shopper-secondary-button" onClick={() => setIsEditing(true)}>
                  Edit Profile
                </button>
              ) : null}
            </div>

            {isEditing ? (
              <div className="shopper-profile-form">
                <div className="shopper-form-group">
                  <label htmlFor="username">Username</label>
                  <input id="username" type="text" value={username} onChange={(event) => setUsername(event.target.value)} />
                </div>
                <div className="shopper-form-group">
                  <label htmlFor="email">Email</label>
                  <input id="email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
                </div>
                <div className="shopper-form-group">
                  <label htmlFor="phone">Phone</label>
                  <input id="phone" type="text" value={phone} onChange={(event) => setPhone(event.target.value)} />
                </div>
                <div className="shopper-form-group">
                  <label htmlFor="address">Address</label>
                  <input id="address" type="text" value={address} onChange={(event) => setAddress(event.target.value)} />
                </div>
                <div className="shopper-form-group">
                  <label htmlFor="role">Role</label>
                  <input id="role" type="text" value={role} readOnly />
                </div>
                <div className="shopper-profile-form__actions">
                  <button type="button" onClick={saveProfile}>
                    Save Changes
                  </button>
                  <button type="button" className="shopper-secondary-button" onClick={() => setIsEditing(false)}>
                    Cancel
                  </button>
                </div>
                {profileSuccess ? <p className="shopper-success-text">{profileSuccess}</p> : null}
                {profileError ? <p className="shopper-error-text">{profileError}</p> : null}
              </div>
            ) : (
              <div className="shopper-profile-grid">
                <div className="shopper-profile-card">
                  <span>Username</span>
                  <strong>{username}</strong>
                </div>
                <div className="shopper-profile-card">
                  <span>Email</span>
                  <strong>{email || "Not provided"}</strong>
                </div>
                <div className="shopper-profile-card">
                  <span>Phone</span>
                  <strong>{phone || "Not provided"}</strong>
                </div>
                <div className="shopper-profile-card">
                  <span>Address</span>
                  <strong>{address || "Not provided"}</strong>
                </div>
                <div className="shopper-profile-card">
                  <span>Role</span>
                  <strong>{role || "Shopper"}</strong>
                </div>
              </div>
            )}

            <button type="button" className="shopper-logout-button" onClick={handleLogout}>
              Logout
            </button>
          </section>
        )}
      </main>

      <nav className="shopper-bottom-nav">
        {navigationItems.map((item) => (
          <button
            key={item.id}
            type="button"
            className={activeSection === item.id ? "active" : ""}
            onClick={() => setActiveSection(item.id)}
          >
            <ShopperIcon
              name={
                item.id === "home"
                  ? "home"
                  : item.id === "categories"
                    ? "categories"
                    : item.id === "cart"
                      ? "cart"
                      : item.id === "orders"
                        ? "orders"
                        : "profile"
              }
            />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}

export default CustomerDashboard;
